
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"fill":"transparent"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"currentColor","d":"M4.284 14.711A5.988 5.988 0 012 10a6 6 0 112.284 4.711zm6.895-1.526A4.486 4.486 0 018 14.5a4.486 4.486 0 01-3.18-1.315C5.454 12.17 6.574 11.5 8 11.5c1.427 0 2.547.67 3.18 1.685zM8 10.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"}}),_c('path',{attrs:{"d":"M12 7.5L14.5 5M12 12.5l2.5 2.5","stroke":"currentColor"}}),_c('circle',{attrs:{"cx":"15.5","cy":"4.5","r":"2.5","fill":"currentColor","transform":"rotate(-90 15.5 4.5)"}}),_c('circle',{attrs:{"cx":"15.5","cy":"15.5","r":"2.5","fill":"currentColor","transform":"rotate(-90 15.5 15.5)"}})])
          )
        }
      }
    